import React from 'react';
import {
    Typography,
    Card,
    CardMedia,
    Box,
    useTheme
} from '@mui/material';
import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const dummyurl = "https://cdn.pixabay.com/photo/2017/11/24/10/43/ticket-2974645_1280.jpg";

const EventCard = ({ event, onClick }) => {
    const theme = useTheme();
    
    return (
        <Card
            onClick={onClick}
            sx={{
                position: 'relative',
                height: { xs: 200, sm: 220 }, // Responsive height
                overflow: 'hidden',
                borderRadius: '12px',
                cursor: 'pointer',
                '&:hover': {
                    transform: 'scale(1.03)',
                    boxShadow: `0 0 15px ${theme.palette.primary.main}`,
                    transition: 'all 0.3s ease-in-out',
                },
                transition: 'all 0.3s ease-in-out',
            }}
        >
            <CardMedia
                component="img"
                image={event.assets[0]?.bannerUrl || dummyurl}
                alt={event.info.name}
                sx={{
                    height: '100%',
                    objectFit: 'cover',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    background: 'linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.8))',
                    color: 'white',
                    padding: { xs: '10px', sm: '12px' },
                }}
            >
                <Typography 
                    variant="subtitle1" 
                    component="div" 
                    sx={{
                        fontWeight: 'bold',
                        mb: 0.5,
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        lineHeight: 1.2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                >
                    {event.info.name}
                </Typography>
                <Typography 
                    variant="caption" 
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: { xs: '0.75rem', sm: '0.8rem' }
                    }}
                >
                    <CalendarTodayIcon sx={{ 
                        fontSize: { xs: 12, sm: 14 },
                        mr: 0.5 
                    }} />
                    {dayjs.utc(event.info.valid_from).local().format('ddd, MMM D, YYYY')}
                </Typography>
            </Box>
        </Card>
    );
};

export default EventCard;